/**
 * This restriction adapter is for checking Gen4 restrictions and utilizing them
 * within Cube. Gen4 restrictions will be specified like this:
 *
 * restriction://Synacor/Portal/Restriction/Constant/Allow/
 * restriction://Synacor/Portal/Restriction/Constant/Deny/
 *
 * Note that each restriction resolution is cached and can only be cleared
 * by using clearCache().
 */

import service from '@cube/framework-service';

export const NAME = 'restriction://(.+)$';

/**
 * Will store all pending and completed calls:
 */
let CACHE = {};

/**
 * Clear all cached restriction resolutions or
 * delete a specific one:
 * @param [String] restriction - An optional restriction to remove without clearing all.
 */
export function clearCache(restriction) {
	if (restriction) {
		delete CACHE[restriction];
	}
	else {
		CACHE = {};
	}
}

export default function isAllowed(restriction) {
	if (!CACHE[restriction]) {
		CACHE[restriction] = service(
			'restriction',
			{ uri: restriction },
			{},
			true
		)
			// Ensure response is a boolean true value:
			.then(response => {
				CACHE[restriction] = response === true;
				return CACHE[restriction];
			})
			// If error occurs, just return false:
			.catch(() => {
				CACHE[restriction] = false;
				return CACHE[restriction];
			});
	}
	return CACHE[restriction];
}


// WEBPACK FOOTER //
// ../node_modules/@cube/restrictions/src/adapters/gen4/index.js